/**
 * Step 03 — Electoral Behaviour
 *
 * Fields: epicNumber, willVoteThisTime, didVoteLastTime,
 * votingFrequency, primaryVotingIssues
 *
 * @module udp-schema/step-03
 */

import { z } from 'zod';

// ─── Main Step 03 Schema ────────────────────────────────────────────────────

export const step03ElectoralSchema = z.object({
  /** Voter ID / EPIC number */
  epicNumber: z.string().trim().optional(),

  /** Will you vote this time? */
  willVoteThisTime: z.enum(['yes', 'no', 'maybe', 'prefer_not_to_say']).optional(),

  /** Did you vote last time? */
  didVoteLastTime: z.enum(['yes', 'no', 'prefer_not_to_say']).optional(),

  /** Voting frequency */
  votingFrequency: z
    .enum(['every_election', 'most_elections', 'sometimes', 'rarely', 'never', 'first_time_voter'])
    .optional(),

  /** Primary voting issues (multi-select string array) */
  primaryVotingIssues: z.array(z.string().trim()).optional(),
});

// ─── Inferred types ─────────────────────────────────────────────────────────

export type Step03ElectoralInput = z.infer<typeof step03ElectoralSchema>;
